import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
let CampaignSectionCanvasNobg = class CampaignSectionCanvasNobg extends USBrandCampaign {
    constructor() {
        super(...arguments);
        this.seen = false;
    }
    render() {
        return html `
    <div class="component">
      <div class="grid">
        <div class="left-col ${this.seen ? `animate` : ``}">
          <div class="card">
              <img src="./media/img/AltsFT-White-Logo.svg" alt="Alternatives by FT logo"/>
              <h2>La forza dei private market</h2>
              <p>Le opportunità nei mercati privati? Straordinarie. Il nostro impegno per renderle accessibili? Ancora di più.<br />Abbattiamo le barriere negli investimenti alternativi e mettiamo a disposizione l'esperienza dei nostri gestori specializzati. È così che il nostro patrimonio gestito in investimenti alternativi ha raggiunto i 258 miliardi di dollari.*</p>
              <a href="https://www.franklintempleton.it/investi-con-noi/competenze-negli-investimenti/alternativi" @click="${this.trackLink}" data-link-title="Scopri Alternatives by Franklin Templeton">Scopri Alternatives by Franklin Templeton</a>
            </div>
        </div>
      </div>
  </div>
        <slot></slot>`;
    }
};
CampaignSectionCanvasNobg.styles = [
    sharedStyles,
    css `
    :host {
        display: flex;
        margin: 0 auto;
        background: transparent;
        padding: 0;
        position: relative;
        z-index: 4;
        align-content: center;
        flex-wrap: wrap;                
    }
    
    .grid {  
      grid-template-columns: repeat(2, 1fr);
      grid-auto-flow: row;
    }

    @media(min-width: 768px) {
        .grid {  
          display: grid;    
        }    
      }    
    
    .left-col {
      justify-self: start;
      align-self: start;
      grid-area: 1 / 1 / 2 / 2;
      width: 100%;
    }
    
    .right-col {
      justify-self: end;
      align-self: start;
      grid-area: 1 / 2 / 2 / 3;
      width: 100%;
   
    }
    .card {
      /*background: #fff;
      padding: 3rem;
      border-radius: 5px 140px 5px 5px;
      */
    }
    h2, p {
      color: var(--white);
    }

    img {
      max-width: 230px;
      margin-bottom: 1rem;
    }

    a {
      display: inline-block;
      background: var(--white);
      padding: 0.6rem 1.25rem;
      border-radius: 45px;
      text-decoration: none;
      color: var(--ft-sky-blue);
    }    

    @media(min-width: 768px) {

      .left-col {
        transform: translateX(50px);
        opacity: 0;      
      }      

      .left-col.animate {
        animation: fade-in-right 2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      }

      p, a {
        font-size: 1.1rem;
      }      

    }

    /* mobile hack */
    @media(max-width: 768px) {
      .component {
        width: 100%;
        margin: 0;
      }

      .card {
        border-radius: 0;
        padding: 2rem;
      }
    }

  `
];
__decorate([
    property({ type: Boolean })
], CampaignSectionCanvasNobg.prototype, "seen", void 0);
CampaignSectionCanvasNobg = __decorate([
    customElement('campaign-section-canvas-nobg')
], CampaignSectionCanvasNobg);
export { CampaignSectionCanvasNobg };
//# sourceMappingURL=campaign-section-canvas-nobg.js.map